/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Center_RightInputs */

const en_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Events to the center right of the video`)
};

const fr_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner les evenements au centre droit de la video`)
};

const de_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionieren Sie die Ereignisse rechts in der Mitte des Videos.`)
};

const it_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiziona gli eventi al centro a destra del video`)
};

const ru_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разместите события в центре справа от видео.`)
};

const es_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colocar eventos en el centro a la derecha del vídeo`)
};

const zh_cn2_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件定位在视频右侧中间位置`)
};

const ja_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをビデオの中央右に配置する`)
};

const hi_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो के केंद्र के दाईं ओर घटनाओं की स्थिति निर्धारित करें।`)
};

const pt_pt2_shortcut_keys_desc_cc_position_center_right = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicione os eventos no centro à direita do vídeo.`)
};

/**
* | output |
* | --- |
* | "Position Events to the center right of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_center_right = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_position_center_right(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_position_center_right(inputs)
	return en_shortcut_keys_desc_cc_position_center_right(inputs)
});